/**
 * @generated SignedSource<<10c6f582b6f208645f591ffa170ad461>>
 * @relayHash dc8a00662ff37b67d74342ec40bed340
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d42636d7783b046b016d9b617758731771505ab2695a72eb1ab950f3c0ec1101

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PlanListQuery$variables = {
  cloudId: string;
  currentURLPath?: AGG$URL | null | undefined;
};
export type PlanListQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PlansList">;
};
export type PlanListQuery = {
  response: PlanListQuery$data;
  variables: PlanListQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider": isMigratePlanNavRelayEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider: {
    readonly get: () => boolean;
  };
});

import isMigratePlanNavRelayEnabled_provider from '@atlassian/jira-relay-provider/src/migrate-plans-navigation-to-relay.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currentURLPath"
},
v2 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v6 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "name": "planId"
          },
          {
            "kind": "ScalarField",
            "name": "title"
          },
          {
            "kind": "ScalarField",
            "name": "isReadOnly"
          },
          {
            "kind": "ScalarField",
            "name": "planStatus"
          },
          {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isFavourite"
              },
              (v4/*: any*/)
            ]
          },
          {
            "concreteType": "JiraScenario",
            "kind": "LinkedField",
            "name": "scenario",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "scenarioId"
              },
              (v4/*: any*/)
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "defaultNavigationItem",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "url"
                      }
                    ],
                    "type": "JiraSoftwareBuiltInNavigationItem"
                  },
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ],
        "type": "JiraPlan"
      },
      (v5/*: any*/)
    ]
  }
],
v7 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "PlanListQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "currentURLPath",
            "variableName": "currentURLPath"
          }
        ],
        "kind": "FragmentSpread",
        "name": "PlansList"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "PlanListQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "favouritePlans",
            "args": [
              (v2/*: any*/),
              {
                "kind": "Literal",
                "name": "filter",
                "value": {
                  "sort": {
                    "order": "DESC"
                  },
                  "type": "PLAN"
                }
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 15
              }
            ],
            "concreteType": "JiraFavouriteConnection",
            "kind": "LinkedField",
            "name": "favourites",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraFavouriteEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v6/*: any*/)
              },
              (v7/*: any*/)
            ]
          },
          {
            "alias": "recentPlans",
            "args": [
              (v2/*: any*/),
              {
                "kind": "Variable",
                "name": "currentURL",
                "variableName": "currentURLPath"
              },
              {
                "kind": "Literal",
                "name": "first",
                "value": 20
              },
              {
                "kind": "Literal",
                "name": "types",
                "value": [
                  "PLAN"
                ]
              }
            ],
            "concreteType": "JiraSearchableEntityConnection",
            "kind": "LinkedField",
            "name": "recentItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSearchableEntityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v6/*: any*/)
              },
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d42636d7783b046b016d9b617758731771505ab2695a72eb1ab950f3c0ec1101",
    "metadata": {},
    "name": "PlanListQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcmigrateplansnavigationtorelayrelayprovider": isMigratePlanNavRelayEnabled_provider
    }
  }
};
})();

(node as any).hash = "c8de83b9c22a2a08040b53650c90d657";

export default node;
